<mat-spinner [diameter]="42"></mat-spinner>
